import { useAuth } from "../contexts/AuthContext";

export function hasAlphaRoleAccess(roles: string[]): boolean {
  return roles.includes("ADMIN")
    || roles.includes("INVESTOR")
    || roles.length === 0;
}

export function isCustomerViewEligible(
  roles: string[],
  rawIsCustomer: unknown
): boolean {
  return rawIsCustomer === "true" && hasAlphaRoleAccess(roles);
}

export function useAlphaAccess(): boolean {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) return false;

  const roles = user?.roles ?? [];
  return hasAlphaRoleAccess(roles);
}
